module.exports = __webpack_public_path__ + "media/images/friends-having-fun-at-restaurant-c95f711213ef98c0233ec64d0fd50313.jpg";